export default __webpack_public_path__ + "static/fachada-principal-d84c8d3e8f868ca5063f3efa6046c114.webp";